<template>
  <v-card v-if="ready" class="elevation-0">
    <v-card-text class="pa-1">
      <bar-chart
        title="Time Utilization in Minutes"
        sub-title='Understand how time is being utilized in each warehouse. "Processing" refers to the time between the "in progress" and "complete" statuses'
        :data="chartData"
        :categories="categories"
        :force-label-middle="true"
        :stacked="false"
        :custom-offset="{ x: 0, y: 0 }"
        :data-label-formatter="formatDataLabels"
        :colors="colors"
        :show-data-labels="true">
      </bar-chart>
    </v-card-text>
  </v-card>
  <v-skeleton-loader v-else class="mx-auto" type="card"></v-skeleton-loader>
</template>

<script>
import insightsMixin from '@/components/mixins/insightsMixin';

/**
 * Appointments by Status Bar Chart
 * @displayName Appointments by Status Bar Chart
 */
export default {
  mixins: [insightsMixin],
  data() {
    return {
      currentRequests: [],
      apiEndpoint: 'appointments/status-times',
      categories: [],
      includeVolumeInUri: false,
      colors: ['#2CB843', '#FADA28', '#FF9340']
    };
  },
  methods: {
    async getData() {
      if (this.selectedWarehouse?.length) {
        this.queryParams.warehouseIds = this.novaCore.pluck(this.selectedWarehouse, 'id');
      }
      const requestData = this.getQueryParams();
      delete requestData.warehouseId;
      const url = `/metrics/${this.apiEndpoint}`;

      const semaphoreKey = encodeURI(`${url}-${JSON.stringify(requestData)}`);

      if (this.currentRequests.includes(semaphoreKey)) {
        return;
      }
      this.currentRequests.push(semaphoreKey);

      axios
        .post(url, requestData)
        .then(response => {
          if (response?.data) {
            this.rawData = this.dataKey ? response.data?.data[this.dataKey] : response.data?.data;
          }
        })
        .finally(
          () => (this.currentRequests = this.currentRequests.filter(r => r !== semaphoreKey))
        );
    },
    formatXAxis(data) {
      return this.novaCore.ucWords(data);
    },
    formatData() {
      this.chartData = [];
      const data = this.rawData;
      this.categories = Object.keys(data).filter(warehouseName => {
        // this removes any warehouses that don't have data for AnY of the times
        return (
          parseInt(data[warehouseName].dwell_time) ||
          parseInt(data[warehouseName].wait_time) ||
          parseInt(data[warehouseName].processing_time)
        );
      });

      if (this.categories?.length) {
        this.chartData.push({
          name: 'Dwell Time',
          data: this.novaCore.pluck(Object.values(data), 'dwell_time').map(dt => {
            return parseInt(dt) || 0;
          })
        });
        this.chartData.push({
          name: 'Wait Time',
          data: this.novaCore.pluck(Object.values(data), 'wait_time').map(dt => {
            return parseInt(dt) || 0;
          })
        });
        this.chartData.push({
          name: 'Processing Time',
          data: this.novaCore.pluck(Object.values(data), 'processing_time').map(dt => {
            return parseInt(dt) || 0;
          })
        });
      }

      this.ready = true;
    },
    formatDataLabels(v) {
      return `${v} min`;
    }
  }
};
</script>
